import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { CurrencyModel } from '../../models/currency_master_model/currency';
import { BackendListModel } from '../../models/common/list.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyMasterApiService {
  base_url = ApiRoutes.CurrencyMaster;

  constructor(
    private http: HttpClient
  ) { }

  getAllCurrency(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<CurrencyModel>> {
    let url = `${this.base_url}currency/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<CurrencyModel>>(String(urlObj));
  }
  // Post Currency
  postCurrency(data: CurrencyModel) {
    let url = `${this.base_url}currency/`;
    return this.http.post<CurrencyModel>(url, data);
  }
  // PUT Currency
  updateCurrency(currId: string, data: CurrencyModel) {
    let url = `${this.base_url}currency/${currId}/`;
    return this.http.put<CurrencyModel>(url, data);
  }
  getCurrencybyID(currId: string) {
    let url = `${this.base_url}currency/${currId}/`;
    return this.http.get<CurrencyModel>(url);
  }
  getAllCountry():
    Observable<BackendListModel<CurrencyModel>> {
    let url = `${this.base_url}country_mapping/`;
    return this.http.get<BackendListModel<CurrencyModel>>(url);
  }
  // getAllCurrencyCountry():
  //   Observable<BackendListModel<CurrencyModel>> {
  //   let url = `${this.base_url}currency_country/`;
  //   return this.http.get<BackendListModel<CurrencyModel>>(url);
  // }

  getAllCurrencyCountry(page_size = 300, page = 1): Observable<BackendListModel<CurrencyModel>> {
    let url = `${this.base_url}currency_country/`;
    let urlObj = new URL(url);
    // urlObj.searchParams.append('name', String(search));
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    return this.http.get<BackendListModel<CurrencyModel>>(String(urlObj));
  }
}